import React from 'react';
import TextField from 'material-ui/TextField';
import mutations from '../../graphql/mutations';
import FlatButton from 'material-ui/FlatButton';
import { compose } from 'react-apollo';
import OverlayController from '../overlay/OverlayController';


class CreateProjectCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            projectName: ''
        };
    }

    didChangeProjectName(event) {
        this.setState({projectName: event.target.value});
    }

    didClickCreateProject(event) {
        event.preventDefault();
        OverlayController.showActivityIndicator();
        this.props.createProject(this.state.projectName)
            .then(({data}) => {
                OverlayController.hideActivityIndicator();
                this.setState({projectName: ''});
            })
            .catch((error) => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        return (
            <div className="project-card create-project-card">
                <TextField hintText="Enter Project Name" value={this.state.projectName} onChange={this.didChangeProjectName.bind(this)} />
                <FlatButton label="Create Project" primary={true} onClick={this.didClickCreateProject.bind(this)} disabled={this.state.projectName.length === 0} />
            </div>
        );
    }
}

export default compose(
    mutations.createProjectMutationHoc
)(CreateProjectCard);



// WEBPACK FOOTER //
// ./src/components/projectList/CreateProjectCard.js